import PitchResult from '../enums/PitchResult.js';

const classifiesAsHomeRun = function(taggedPitchResultKey){
    if (typeof taggedPitchResultKey !== 'string'){
        return false;
    }

    return taggedPitchResultKey === PitchResult.HomeRun.key;
};

export default classifiesAsHomeRun;